import { lazy, Suspense } from "react";

import { LoadingIndicatorFullPage } from "../../../cc-ui/components";

const PipelineLazy = lazy(() => import("./Pipeline").then((module) => ({ default: module.Pipeline })));

export const PipelineAsync = () => (
  <Suspense fallback={<LoadingIndicatorFullPage open />}>
    <PipelineLazy />
  </Suspense>
);
